import {Flex, Text} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

export function AuthFooter() {
  const {t} = useTranslate('common')

  return (
    <footer>
      <Flex padding="8" justifyContent="space-between">
        <Text fontSize="sm" color="fg.subtle">
          @ {new Date().getFullYear()} {t('app_name')}. {t('all_rights_reserved')}.
        </Text>

        <Flex gapX="2">
          <Text fontSize="sm" color="fg.subtle">
            {t('privacy_policy')}
          </Text>
          <Text fontSize="sm" color="fg.subtle">
            |
          </Text>
          <Text fontSize="sm" color="fg.subtle">
            {t('terms_of_service')}
          </Text>
        </Flex>
      </Flex>
    </footer>
  )
}
